import React, { useEffect, useState } from "react";
import { Typography, Box, Button } from "@mui/material";
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import GoogleIcon from "../../Assets/Icon/GoogleIcon";
import '../../CSS/LoginComponent/Login.css'
import { getUserProfile, loginUser, loginWithGoogle } from "../../api/authApi";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import { clearAuthTokens, setAuthTokens } from "../../utils/authStorage";
import { preloadGoogleAuth, requestGoogleAuthCode } from "../../utils/googleAuth";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });

  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);

  useEffect(() => {
    preloadGoogleAuth();
  }, []);

  const handleChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value
    });
  };

  const handleLogin = async () => {
    try {
      setLoading(true);

      // Step 1: Login — get the JWT token
      const loginResult = await loginUser(formData);
      const token = loginResult?.token || loginResult?.accessToken || loginResult;
      const refreshToken = loginResult?.refreshToken;

      // Step 2: Fetch the real profile using the token
      // The token is saved first so axiosInstance interceptor picks it up
      setAuthTokens({ accessToken: token, refreshToken });
      const profileData = await getUserProfile();

      // Step 3: Commit to context
      login(token, profileData, refreshToken);

      alert("Login Successful!");
      navigate('/');

    } catch (error) {
      console.error(error);
      clearAuthTokens();
      alert("Login Failed");
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      setGoogleLoading(true);

      const authCode = await requestGoogleAuthCode();
      const loginResult = await loginWithGoogle(authCode);
      const token = loginResult?.token || loginResult?.accessToken || loginResult;
      const refreshToken = loginResult?.refreshToken;

      setAuthTokens({ accessToken: token, refreshToken });
      const profileData = await getUserProfile();
      login(token, profileData, refreshToken);

      alert("Login Successful!");
      navigate('/');
    } catch (error) {
      console.error(error);
      clearAuthTokens();
      alert(error?.message === "Missing REACT_APP_GOOGLE_CLIENT_ID"
        ? "Google Client ID is not configured."
        : "Google Sign In Failed");
    } finally {
      setGoogleLoading(false);
    }
  };

  return (
    <div className="login-container">

      <div className="contact-name-row">
        <img src="/sejiwa-logo-2.png" alt="Sejiwa Logo" className="contact-logo" />
        <h1 className="contact-name">Sejiwa</h1>
      </div>

      <Typography variant="body1" color="text.secondary" gutterBottom marginBottom={4}>
        Login To Your Account
      </Typography>

      {/* Temporarily hidden normal sign up/in
      <div className="input-wrapper">
        <div className="email-container">
          <EmailIcon className="input-icon" />
          <input type="text" placeholder="Email" className="input-field" onChange={(e) => handleChange("email", e.target.value)} />
        </div>
      </div>

      <div className="input-wrapper">
        <div className="password-container">
          <LockIcon className="input-icon" />
          <input type="password" placeholder="Password" className="input-field" onChange={(e) => handleChange("password", e.target.value)} />
        </div>
      </div>


      <Box className="forgot-password-wrapper">
        <Typography
          component="a"
          href="#"
          fontSize={14}
          className="forgot-password-link"
        >
          Forgot password?
        </Typography>
      </Box>


      <Button
        variant="contained"
        disableElevation
        onClick={handleLogin}
        disabled={loading}
        sx={{
          width: "100%",
          textTransform: "none",
          backgroundColor: "#55C2C3",
          borderRadius: "30px",
          paddingY: "10px",
          fontSize: "16px",
          marginBottom: "30px",
          "&:hover": { backgroundColor: "#48A6A7", transition: "0.3s" }
        }}
      >
        {loading ? "Logging In..." : "Login"}
      </Button>



      <div className="divider-row">
        <hr className="divider-line" />
        <Typography color="text.secondary" marginInline={5}>or</Typography>
        <hr className="divider-line" />
      </div>
      */}


      <Button
        variant="contained"
        disableElevation
        onClick={handleGoogleLogin}
        disabled={loading || googleLoading}
        sx={{
          width: "100%",
          textTransform: "none",
          color: "#333",
          backgroundColor: "#F2F2F2",
          borderRadius: "30px",
          gap: "10px",
          paddingY: "10px",
          fontSize: "16px",
          marginBottom: "20px",
          "&:hover": { backgroundColor: "#E8E8E8", transition: "0.3s" }
        }}
      >
        <GoogleIcon className="google-icon" />
        {googleLoading ? "Opening Google..." : "Sign in with Google"}
      </Button>



      {/* Temporarily hidden sign up link
      <Typography variant="body1" color="text.secondary" fontSize={16}>
        Don’t you have an account?{" "}
        <Typography
          component="a"
          href="/register"
          className="signup-link"
        >
          Sign Up
        </Typography>
      </Typography>
      */}

    </div>
  );
};

export default Login;
